import {OAuthResultEvent} from "../../login/types";
import SettingsApi from "../../../apis/SettingsApi";

export default function useExternalService(settingsApi: SettingsApi) {
    const getProvider = (service: string) => {
        switch (service) {
            case "Strava":
                return 'strava';
            default:
                return 'garmin';
        }
    }

    const createOAuthMessageHandler = async (event: OAuthResultEvent, shortToken: string | null = null) => {
        if (event.data?.type === "link_service" && event.data?.origin === "yna") {
            if (event.data.payload.Error) {
                return new Promise((_, reject) =>
                    reject({ result: false, error: event.data.payload.Error }));
            }
            if (event.data?.payload) {
                await settingsApi.linkExternalService(
                  event.data.payload.UserId,
                  event.data.payload.AccessToken,
                  event.data.payload.RefreshToken,
                  event.data.payload.AccessTokenSecret,
                  event.data.payload.ProviderIdentifier,
                  event.data.payload.ProviderName,
                  shortToken
                );
            }

            return new Promise(resolve => resolve({
                identifier: event.data.payload.Identifier,
                provider: event.data.payload.Provider,
                redirect: event.data.payload.Redirect,
                result: true,
                error: undefined
            }));
        }

        return new Promise((_, reject) => reject({ result: false }))
    }
    
    const openOAuthWindow = (service: string, shortToken: string): void => {
        const provider = getProvider(service);
        
        const url =
          `${process.env.REACT_APP_BASE_URL}/auth/api/v1/external/services/${provider}` +
          `?short_token=${encodeURIComponent(shortToken)}`;
        
        const popup = window.open(
          url,
          'oauth-popup',
          'toolbar=no,menubar=no,status=no,width=800,height=600'
        );
        
        const receiveMessage = (event: MessageEvent) => {
            if (event.data?.type !== "link_service" || event.data?.origin !== "yna") {
                return;
            }
            
            window.removeEventListener('message', receiveMessage);
            
            createOAuthMessageHandler(event, shortToken)
              .finally(() => {
                  setTimeout(() => popup?.close(), 100);
              });
        };
        
        window.addEventListener('message', receiveMessage);
    };
    
    return [openOAuthWindow];
}